<template>
  <v-card>
    <div class="person__info__pre-header">
      <div class="d-flex align-center pa-2">
        <h4 class="secondary--text font-weight-bold ml-6">
          {{ $t('fleet_management.geofences.geofence_details.edit_geofence') }}
        </h4>
      </div>
      <v-divider></v-divider>
    </div>
    <v-form ref="form" v-if="valid">
      <v-container class="px-8 px-lg-8 px-xl-8 pb-6 pt-4">
        <v-row>
          <v-col cols="5">
            <v-text-field
              v-model.trim="name"
              :counter="40"
              :label="
                $t(
                  'fleet_management.geofences.geofence_details.labels.edit_geofence_name'
                )
              "
              :rules="nameRules"
              filled
              dense
              required
              ref="geofenceName"
            ></v-text-field>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <hr class="divider-dotted" />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <h4 class="secondary--text mb-3">
              {{
                $t(
                  'fleet_management.geofences.create_geofence.labels.form_sub_title'
                )
              }}
            </h4>
            <h5 class="tertiary--text">
              {{
                $t(
                  'fleet_management.geofences.create_geofence.labels.coordinates_polygon_hint'
                )
              }}
            </h5>
          </v-col>
        </v-row>

        <v-row class="footer">
          <v-col>
            <v-row justify="space-between">
              <v-col cols="auto">
                <v-btn
                  :to="{ name: 'geofences' }"
                  outlined="true"
                  color="secondary"
                  rounded
                  >{{
                    $t(
                      'fleet_management.geofences.geofence_details.labels.form_edit_geofence_cancel_button'
                    )
                  }}</v-btn
                >
              </v-col>
              <v-col cols="auto">
                <v-btn
                  color="tertiary white--text"
                  rounded
                  :disabled="!geofenceChange"
                  @click="saveEditedZone"
                  >{{
                    $t(
                      'fleet_management.geofences.geofence_details.labels.form_edit_geofence_accept_button'
                    )
                  }}</v-btn
                >
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-form>
    <Dialog
      v-if="showDialog"
      idCancelButton="idBtnZonasCancelarModificacion"
      idSubmitButton="idBtnZonasAceptarModificacion"
      @cancelButtonPressed="showDialog = false"
      :loading="dialog.loading"
      :showDialog="showDialog"
      @submitButtonPressed="dialog.submitAction"
      :text="dialog.text"
      :title="dialog.title"
      type="warning"
    />
  </v-card>
</template>

<script>
import { GEOFENCE_MIN_RADIUS, GEOFENCE_MAX_RADIUS } from '@leapsight/styleguide'
import { i18n } from '@leapsight/portal'
import Dialog from '@/components/dialog/Dialog'
import { GeofencesHelpers } from '@/helpers/mainExports.js'
import { mapGetters } from 'vuex'
import store from '@/store'

export default {
  components: {
    Dialog
  },
  props: {
    geofenceData: {
      type: Object
    }
  },
  data() {
    return {
      polygon: null,
      dialog: {
        loading: false,
        text: '',
        title: '',
        type: '',
        submitAction: ''
      },
      id: null,
      name: '',
      loadingDialog: false,
      nameRules: [
        v =>
          !!v ||
          i18n.t('fleet_management.persons.new_person.rules.name_required'),
        v =>
          (v && v.length <= 40) ||
          i18n.t(
            'fleet_management.geofences.create_geofence.rules.character_length'
          ),
        v =>
          (v && v.length >= 2) ||
          i18n.t(
            'fleet_management.geofences.create_geofence.rules.character_length'
          ),
        v =>
          /^[a-zA-Z0-9áéíóúüÁÉÍÓÚÜñÑçÇâêîôûÂÊÎÔÛàèìòùÀÈÌÒÙäöüÄÖÜßëïÿËÏŸ#$&^\[\]_ -.\\s]+$/gi.test(
            v
          ) || i18n.t('fleet_management.agents.create.errors.invalid_name')
      ],
      oldGeofence: {},
      routeTo: { name: 'GeofencesList' },
      showDialog: false,
      geofenceChange: false,
      coordinates: [],
      originalCoordinates: [],
      valid: true
    }
  },
  methods: {
    getGeofence(currentRoute) {
      const response = currentRoute
      this.loading = false
      if (!response.hasOwnProperty('error')) {
        this.id = response.id
        this.name = response.data.properties.name

        this.oldGeofence = Object.assign({}, response.data)
      }
    },
    newPolygon(data) {
      const map = GeofencesHelpers.getMap()
      const polygonOptions = {
        path: data,
        strokeColor: '#8079b7',
        editable: true,
        strokeOpacity: 0.8,
        strokeWeight: 2,
        fillColor: '#554da0',
        fillOpacity: 0.35
      }
      this.polygon = new google.maps.Polygon(polygonOptions)
      this.polygon.setMap(map)
      const bounds = new google.maps.LatLngBounds()
      this.polygon.getPaths().forEach(function(path) {
        path.forEach(function(latlng) {
          bounds.extend(latlng)
          map.fitBounds(bounds)
        })
      })
    },
    getCoordinates(payload) {
      const coordinates = []
      for (let i = 0; i < payload.length; i++) {
        const element = payload[i]
        const coordinate = { lng: element[0], lat: element[1] }
        coordinates.push(coordinate)
      }
      return coordinates
    },
    saveZone() {
      this.dialog.loading = true
      const coord = this.geofenceData.data.geometry.coordinates[0]

      let isCoordValid = false

      if (this.coordinates.length > 0) {
        isCoordValid =
          this.coordinates[0][0] !==
            this.coordinates[this.coordinates.length - 1][0] ||
          this.coordinates[0][1] !==
            this.coordinates[this.coordinates.length - 1][1]
      }

      if (isCoordValid)
        this.coordinates.push([this.coordinates[0][0], this.coordinates[0][1]])

      const payload = {
        id: this.id,
        type: 'Feature',
        geometry: {
          type: 'Polygon',
          coordinates: [this.coordinates.length > 0 ? this.coordinates : coord]
        },
        properties: {
          name: this.name
        }
      }
      GeofencesHelpers.updatePolygon(payload)
        .then(() => {
          this.dialog.loading = false
          this.showDialog = false
          this.$router.push({ name: 'geofences' })
          const snackbar = {
            color: 'success',
            text: i18n.t(
              'fleet_management.geofences.geofence_details.alerts.geofence_edited'
            )
          }
          store.dispatch('ui/setSnackbar', snackbar)
        })
        .catch(error => {
          this.dialog.loading = false
          this.showDialog = false
          const errorText = GeofencesHelpers.getErrorMessageByCode(error.error)
          const snackbar = {
            text: errorText
          }
          store.dispatch('ui/setSnackbar', snackbar)
        })
    },
    saveEditedZone() {
      if (this.$refs.form.validate()) {
        this.showDialog = true
        this.dialog.text = i18n.t(
          'fleet_management.geofences.geofence_details.alerts.card_text_confirm_edit_geofence'
        )
        this.dialog.title = i18n.t(
          'fleet_management.geofences.geofence_details.alerts.attention'
        )
        this.dialog.submitAction = this.saveZone
      }
    },
    handlePolygonPathEvents() {
      const path = this.polygon.getPath()
      this.coordinates = []
      for (let i = 0; i < path.length; i++) {
        this.coordinates.push([path.getAt(i).lng(), path.getAt(i).lat()])
      }
      if (this.originalCoordinates.length === this.coordinates.length) {
        let outerIndex = 0
        while (
          outerIndex < this.originalCoordinates.length &&
          this.originalCoordinates[outerIndex].lng ===
            this.coordinates[outerIndex][0] &&
          this.originalCoordinates[outerIndex].lat ===
            this.coordinates[outerIndex][1]
        ) {
          outerIndex++
        }
        this.geofenceChange = outerIndex !== this.originalCoordinates.length
      } else {
        this.geofenceChange = true
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['session']),
    formHasNotChanged() {
      let value = true
      if (this.name !== '') {
        if (this.name !== this.oldGeofence.properties.name) value = false
      }
      return value
    }
  },

  created() {
    this.getGeofence(this.geofenceData)
    const coordinates = this.getCoordinates(
      this.geofenceData.data.geometry.coordinates[0]
    )
    this.originalCoordinates = coordinates
    this.newPolygon(coordinates)
  },
  watch: {
    // En cada inserción, eliminación, o redefinición de un punto en el polígono,
    // se resetean las coordenadas y se habilita el botón de guardado según corresponda
    polygon() {
      const path = this.polygon.getPath()
      google.maps.event.addListener(path, 'insert_at', () => {
        this.handlePolygonPathEvents()
      })
      google.maps.event.addListener(path, 'remove_at', () => {
        this.handlePolygonPathEvents()
      })
      google.maps.event.addListener(path, 'set_at', () => {
        this.handlePolygonPathEvents()
      })
    },
    name(newName) {
      this.geofenceChange = newName !== this.oldGeofence.properties.name
    }
  },

  beforeDestroy() {
    //El condicional asegura que hayamos tenido una vista donde se renderizo el mapa
    //Frente a un error del request getGeofense no se llega a crear el mismo
    if (Object.keys(this.polygon).length > 0) {
      this.polygon.setMap(null)
      const map = GeofencesHelpers.getMap()
      google.maps.event.clearListeners(map, 'click')
    }
  }
}
</script>

<style lang="scss" scoped>
.orange--text {
  color: var(--orange) !important;
}
.dialog-attention {
  border: 2px solid var(--orange);
}
</style>
